import { environment } from '@/environments/environment';
import { ILogsOverride } from './logs-override.model';
import { disableLogs, overrideLogs } from './logs-override.functions';

export class LogOverride {
  static initialize(config: ILogsOverride = environment): void {
    if (config.production) {
      disableLogs();
    } else {
      const originalLog = window.console.log;
      overrideLogs(config, originalLog);
    }
  }
}
